"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = TopicCard;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const react_native_1 = require("react-native");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
const store_1 = require("../../store");
const document_1 = require("../../store/selectors/document");
const user_1 = require("../../slices/user");
const appState_1 = require("../../slices/appState");
const useDevice_1 = require("../../hooks/useDevice");
const useAppQuota_1 = require("../../hooks/useAppQuota");
const Linkable_1 = __importDefault(require("../ui-components/Linkable"));
const AppText_1 = require("../AppText");
const spacing_1 = require("../../common/spacing");
const borders_1 = require("../../common/borders");
const colors_1 = require("../../common/colors");
const constants_1 = require("../../common/constants");
const useDocument_1 = __importDefault(require("../../hooks/useDocument"));
const native_1 = require("@react-navigation/native");
function TopicCard({ icon, topic, description, link }) {
    const { isMobileScreen } = (0, useDevice_1.useDevice)();
    const dispatch = (0, store_1.useAppDispatch)();
    const [isHovered, setIsHovered] = (0, react_1.useState)(false);
    const { params } = (0, native_1.useRoute)();
    const { hasPendingMessageQuota } = (0, useAppQuota_1.useAppQuota)();
    const documentJson = (0, react_redux_1.useSelector)(document_1.selectDocumentJson);
    const isDocumentTyping = (0, react_redux_1.useSelector)((state) => state.getUserOptions.IsCharacterTyping);
    const isChatImageLoading = (0, react_redux_1.useSelector)(document_1.selectIsImageLoading);
    const { startDocumentConversation } = (0, useDocument_1.default)();
    const isStreaming = (0, react_1.useMemo)(() => (!Boolean(params) || isDocumentTyping), [isDocumentTyping, params]);
    const handlePress = (0, react_1.useCallback)(() => {
        if (description) {
            if (hasPendingMessageQuota) {
                dispatch((0, user_1.setAutoSentMessage)(`Tell me briefly about in ${documentJson.language}:\n${description.trim()}`));
                startDocumentConversation({
                    documentJson,
                    shareId: params?.shareId
                });
            }
            else {
                dispatch((0, appState_1.setAppError)(constants_1.OUT_OF_QUOTA_MESSAGES));
            }
        }
    }, [
        description,
        documentJson,
        hasPendingMessageQuota,
        startDocumentConversation,
        params,
        dispatch,
    ]);
    const handleHoverIn = (0, react_1.useCallback)(() => {
        setIsHovered(true);
    }, []);
    const handleHoverOut = (0, react_1.useCallback)(() => {
        setIsHovered(false);
    }, []);
    return ((0, jsx_runtime_1.jsx)(Linkable_1.default, { href: link, children: (0, jsx_runtime_1.jsxs)(react_native_1.Pressable, { onHoverIn: !isStreaming ? handleHoverIn : undefined, onHoverOut: !isStreaming ? handleHoverOut : undefined, disabled: isStreaming || isChatImageLoading, onPress: isStreaming ? undefined : handlePress, style: ({ pressed }) => [
                styles.container,
                !isStreaming && isHovered && styles.containerHovered,
                !isStreaming && pressed && styles.containerPressed
            ], children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.content, children: [icon && ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.iconContainer, children: (0, jsx_runtime_1.jsx)("span", { style: styles.icon, children: icon }) })), (0, jsx_runtime_1.jsxs)(AppText_1.AppText, { style: [styles.text, isMobileScreen && styles.textMobile], children: [topic && ((0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: [styles.text, isMobileScreen && styles.textMobile, styles.topic], children: `${topic}` })), description] })] }), !isStreaming && ((0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faCircleArrowRight, style: [styles.linkIcon, isHovered && styles.linkIconHovered] }))] }) }));
}
;
const styles = react_native_1.StyleSheet.create({
    container: {
        backgroundColor: '#1B1B22',
        textDecorator: 'none',
        gap: spacing_1.Spacing.SPACING_3XL,
        flexDirection: 'row',
        alignItems: 'center',
        paddingVertical: 14,
        paddingHorizontal: spacing_1.Spacing.SPACING_XL,
        borderRadius: borders_1.Borders.RADIUS_XL,
    },
    containerHovered: {
        backgroundColor: `${colors_1.Colors.PRIMARY_300}35`,
    },
    containerPressed: {
        opacity: 0.8,
    },
    content: {
        gap: spacing_1.Spacing.SPACING_XL,
        flexDirection: 'row',
        alignItems: 'center',
        flex: 1,
    },
    iconContainer: {
        width: 40,
    },
    icon: {
        fontSize: 32,
    },
    text: {
        color: colors_1.Colors.DARK_100,
        fontSize: 16,
        fontWeight: '400',
        lineHeight: 28,
    },
    textMobile: {
        fontSize: 14,
        lineHeight: 16.8,
    },
    topic: {
        color: 'white',
        fontWeight: '700',
    },
    linkIcon: {
        color: 'white',
        fontSize: 16,
        opacity: 0,
    },
    linkIconHovered: {
        opacity: 1,
    }
});
